import React from 'react';
import ReactDOM from 'react-dom/client';
// Design system first: it is the base layer, so every component stylesheet
// imported later can override it. (Imported last, its utility classes such as
// .container/.card silently beat the component rules built on top of them.)
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
